module.exports = __webpack_public_path__ + "img/ora_logo.15c0c409.png";